<template>
  <div class="resource-list">
    <h3>{{title}}</h3>
    <JourneyMedia v-if="media" :media="media"/>
    <div class="description" v-html="description"></div>
    <ul class="resources">
      <li v-for="resource in resources">
        <a :href="`/resource-library/${resource.ref}`" @click="handleResourceClick"> 
          <span class="name"> {{resource.name}} </span>
          <span :class="`checkbox ${started && resource.complete ? 'complete' : ''}`">
            <Complete v-if="started && resource.complete"></Complete>
            <RightArrow v-else fill="white" :opacity="1"></RightArrow>
          </span>
        </a>
      </li>
    </ul>
  </div>
</template>

<style lang="less" scoped>
  @import "./shared.less";
  .resource-list {
    .resources {
      li {
        margin: 15px 0;
        a{
          display: flex;
          justify-content: space-between;
          align-items: center;
          
          &:hover{
            .name{
              color: #FFF;
            }
            .checkbox{
              background: #5c5c5c;
              &.complete{
                background: orange;  
              }
            }
          }
        }
        .name {
          text-decoration: underline;
          color: #c0c0c0;
          -webkit-transition: color 0.2s ease-out;
          transition: color 0.2s ease-out;
        }
        .checkbox {
          flex-shrink: 0;
          background: #3c3c3c;
          border-radius: 999px;
          padding: 1px 5px;
          font-weight: bold;
          color: white;
          width: 32px;
          height: 32px;
          text-align: center;
          margin-left: 5px;
          position: relative;
          -webkit-transition: background 0.2s ease-out;
          transition: background 0.2s ease-out;
          .action-icon{
            position: relative;
            top: 3px;
            @media (max-width: 380px){
              top: 2px;
            }
          }
          &.complete {
            background: orange;
            padding: 5px 0 0 2px;
            span{
              padding: 2px 3px 0 0;
            }
          }
        }
      }
    }
  }
</style>

<script>
import { mapActions, mapState } from "vuex";
import RightArrow from "@/common/icons/RightArrow"
import Complete from "@/common/icons/Complete"
import JourneyMedia from "./JourneyMedia";

export default {
  components: {RightArrow, Complete, JourneyMedia},
  props: {
    resources: {
      type: Array
    }, 
    description: {
      type: String,
      default() {
        return this.$t('message.complete-these-resources');
      }
    },
    title: {
      type: String,
      default() {
        return this.$t('message.resources-in-focus');
      } 
    },
    media: {
      type: Object,
    },
  },
  computed: {
    started() {
      return this.journey?.started;
    },
    ...mapState({journey: state => state.journeys.selectedJourneyDetails}),
  },
  methods: {
    handleResourceClick(event) {
      if (!this.started) {
        event.preventDefault();
        this.promptStartJourney();
      }
    },
    ...mapActions(["promptStartJourney"])
  }
}
</script>